package ru.it_mozaika.sender.js.application.components.subscribers

import mui.icons.material.ErrorOutline
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.components.commonButtonComponent
import ru.it_mozaika.sender.common.models.SubscriberData
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.styles.styledDialog
import web.cssom.*

external interface ConfirmDialogProps: Props {
    var requestWithErrors: List<SubscriberData>
    var errors: List<String>
    var isOpen: Boolean
    var originalCount: Int
    var onClose: () -> Unit
    var onDownloadClick: () -> Unit
}

val confirmDialog = FC<ConfirmDialogProps> {props ->
    val backdrop = useContext(BackdropContext)

    Dialog{
        this.open = props.isOpen
        sx{
            width = 100.pct
            marginTop = 56.px
        }
        asDynamic().maxWidth = "xl"

        DialogTitle {
            +"В результате загрузки обнаружены ошибки. Могут быть загружены ${props.requestWithErrors.size} из ${props.originalCount}"
        }
        DialogContent {
            Stack {
                direction = responsive(StackDirection.column)
                this.divider = Divider.create() {
                    orientation = Orientation.horizontal
                    flexItem = true
                }
                asDynamic().spacing = 2
                sx {
                    alignItems = AlignItems.center
                    border = 2.px
                }
                Stack{
                    sx{
                        alignItems = AlignItems.center
                    }
                    spacing = responsive(2)
                    direction = responsive(StackDirection.row)
                    ErrorOutline {
                        fontSize = SvgIconSize.large
                        color = SvgIconColor.error
                    }
                    InputLabel {
//                        sx {
//                            fontSize = FontSize.medium
//                            color = Color("black")
//                        }
                        +"При загрузке некорректные значения будут проигнорированны"
                    }
                }
                DialogContentText {
                    List{
                        props.errors.forEach {
                            ListItemText {
                                primary = ReactNode(it)
                            }
                        }
                    }
                }
            }
        }
        DialogActions {
            sx{
                alignItems = AlignItems.flexEnd
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    + "Всё равно загрузить"
                    disabled = props.requestWithErrors.isEmpty()
                    onClick = {
                        backdrop.show()
                        props.onDownloadClick()

                    }
                }
                Button {
                    variant = ButtonVariant.outlined
                    +  "Отмена"
                    color = ButtonColor.error
                   onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}